<template>
  <div class="main row">
    <div class="content-container row">
      <img class="img" src="@/assets/img/logo.svg" alt="yanbaocool logo">
      <span v-if="authSuccess" >正在跳转到研究报告...</span>
      <div v-else class="red">见微用户信息验证失败</div>
    </div>
  </div>
</template>

<script>
import Helper from '@/helpers/localStorageHelper';
import api from '@/rest/questionQuery';
import {
  AUTH_TOKEN_KEY, JIANWEI_AUTH_TOKEN_KEY
} from '@/helpers/constants';

export default {
  data() {
    return {
      authSuccess: true,
      token: null
    };
  },
  methods: {
    async handleUrl() {
      this.token = this.$route.query.authtoken;
      Helper.setItem(JIANWEI_AUTH_TOKEN_KEY, this.token);
      Helper.removeItem(AUTH_TOKEN_KEY);
      const checkFlag = await this.jianWeiUserCheck();
      if (!checkFlag) {
        this.authSuccess = false;
      }
      this.$router.replace('/');
    },
    async jianWeiUserCheck() {
      if (!this.token) {
        this.$message.error('URL错误，请检查URL格式是否正确');
        return false;
      }
      try {
        await api.jianWeiUserCheck(this.token);
        return true;
      } catch (err) {
        this.$message.error('见微用户信息验证失败');
        return false;
      }
    }
  },
  watch: {
    $route() {
      this.handleUrl();
    }
  },
  mounted() {
    this.handleUrl();
  },
  destroyed() {
    eventBus.$emit('userLogin');
  }
};
</script>

<style lang="scss" scoped>
  .main {
    justify-content: center;
    width: 100%;
    height: 100%;
    .content-container {
      flex-direction: column;
      margin-top: 20%;
      .img {
        margin-bottom: 24px;
      }
      .red {
        color: #eb0f0f;
      }
    }
  }
</style>
